export default __webpack_public_path__ + "static/media/missionIcon.296911f5.svg";